import * as pdfMake from 'pdfmake/build/pdfmake'
import * as pdfFonts from 'pdfmake/build/vfs_fonts'
import { GENERAL_PDF_FONT_TYPES } from './constants'
import { TDocumentDefinitions } from 'pdfmake/interfaces'

// setting up vfs env for PDF generation overview
// need for library getting required font types for internal directories
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
pdfMake.vfs = { Roboto: pdfFonts }

export const generatePaginatedFooterUpdatedUI =
  (): TDocumentDefinitions['footer'] => (currentPage, pageCount) => {
    return currentPage === pageCount
      ? {
          margin: [40, 10, 40, 30],
          stack: [
            {
              text: 'Page ' + currentPage + ' of ' + pageCount,
              fontSize: 9,
              color: '#333',
              alignment: 'left',
              margin: [0, 0, 0, 6]
            },
            {
              text: 'If you have any questions concerning this remittance, contact: support@community.ominnovations.health',
              alignment: 'center',
              fontSize: 9,
              color: '#333'
            },
            {
              text: 'THANK YOU FOR YOUR BUSINESS!',
              alignment: 'center',
              bold: true
            }
          ]
        }
      : {
          margin: [40, 10, 40, 30],
          columns: [
            {
              text: 'Page ' + currentPage + ' of ' + pageCount,
              fontSize: 9,
              color: '#333',
              alignment: 'left'
            }
          ]
        }
  }

export const generatePaginatedFooter =
  (): TDocumentDefinitions['footer'] => (currentPage, pageCount) => {
    return {
      columns: [
        {
          text: 'Page ' + currentPage.toString() + ' of ' + pageCount
        }
      ],
      marginLeft: 36
    }
  }

export const generatePDFDoc = (
  docDefinition: TDocumentDefinitions,
  fileName: string,
  callback?: () => void
) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  pdfMake.fonts = GENERAL_PDF_FONT_TYPES
  const pdfDocGenerator = pdfMake.createPdf(docDefinition)
  pdfDocGenerator.getBlob((blob) => {
    const url = window.URL.createObjectURL(blob)
    const anchor = document.createElement('a')
    anchor.href = url
    anchor.setAttribute('download', fileName)
    anchor.click()
    anchor.remove()
    window.URL.revokeObjectURL(url)
    callback?.()
  })
}
